import { UserManager, WebStorageStateStore, User } from 'oidc-client-ts'
import type { UserManagerSettings } from 'oidc-client-ts'

class OidcService {
  private userManager: UserManager
  public settings: UserManagerSettings

  constructor() {
    const oidc = (window as any)?.configuration?.oidc || {}

    Object.keys(oidc).forEach((key) => {
      switch (`${oidc[key]}`.trim()) {
        case '__Oidc.AuthorityUrl__':
        case '__Oidc.RedirectUri__':
        case '__Oidc.ClientId__':
        case '__Oidc.SilentRedirectUri__':
        case '__Oidc.SsoMode__':
        case '__Oidc.PostLogoutRedirectUri__':
        case '__Oidc.Scope__':
          oidc[key] = ''
          break
      }
    })

    this.settings = {
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      authority: oidc?.authority || '',
      client_id: oidc?.client_id || '',
      redirect_uri: `${window.location.origin}/auth/sso`, // oidc?.redirect_uri || '',
      silent_redirect_uri: `${window.location.origin}/auth/sso-silent`,
      post_logout_redirect_uri: `${window.location.origin}/logout`,
      scope: oidc?.scope || '',
      loadUserInfo: true
    }

    // Log.setLogger(console)
    // Log.setLevel(Log.INFO)

    this.userManager = new UserManager(this.settings)
  }

  public getUser(cb?: Function): Promise<User> {
    return this.userManager.getUser().then((user) => {
      if (cb && typeof cb === 'function') cb(user)
      return user
    })
  }

  public signinRedirect() {
    return this.userManager.signinRedirect()
  }

  public signinRedirectCallback = () => {
    return this.userManager.signinRedirectCallback()
  }

  public signinSilent = () => {
    return this.userManager.signinSilent()
  }

  public signinSilentCallback = () => {
    return this.userManager.signinSilentCallback()
  }

  public signinCallback = () => {
    return this.userManager.signinCallback()
  }

  public signoutRedirect = () => {
    return this.userManager.signoutRedirect()
  }

  public signoutSilent = () => {
    return this.userManager.signoutSilent()
  }

  public getAccessToken = () => {
    return this.userManager.getUser()?.then((data: any) => {
      return data ? data.access_token : null
    })
  }

  public hasAuthority = () => {
    return `${this.settings.authority}`.length > 0
  }
}

export default new OidcService()
